<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item-group color="primary">
          <div v-for="(item, i) in menuItems" :key="i">
            <v-list-item
              v-if="
                userRoles !== undefined &&
                  userRoles.length > 0 &&
                  item.roles.includes(userRoles[0])
              "
              link
              text
              :class="isActive(item.path)"
              @click="$router.push(item.path).catch((err) => {})"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <v-list-item @click="logout()" link text>
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Salir</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ aplicationName }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-col cols="2">
        <v-select
          :value="cursoActual"
          :items="cursos"
          @change="cursoChange"
          label="Curso"
          item-text="anio"
          return-object
          prepend-icon="mdi-calendar"
          single-line
        ></v-select>
      </v-col>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <slot />
      </v-container>

      <v-snackbar
        v-model="snack.active"
        :timeout="snack.timeout"
        :color="snack.color"
      >
        {{ snack.text }}
        <v-btn text @click="resetSnack">Cerrar</v-btn>
      </v-snackbar>
    </v-content>
    <v-footer color="primary" app dark padless>
      <v-col class="text-center" cols="12">
        <span>&copy; {{ copyrightYear }}</span
        >&nbsp;<span>{{ copyrightText }}</span>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "BaseLayout",
  data() {
    return {
      aplicationName: process.env.VUE_APP_APPLICATION_NAME,
      copyrightYear: process.env.VUE_APP_COPYRIGHT_YEAR,
      copyrightText: process.env.VUE_APP_COPYRIGHT_TEXT,
      drawer: null,
      menuItems: [],
    };
  },
  created() {
    this.$store.dispatch("Auth/ASIGNAR_VALORES_USUARIO");
    this.$store.dispatch("App/INITIALIZE_CURSOS");
    this.$store.dispatch("App/INITIALIZE_LOCALIZACIONES");
    this.$store.dispatch("Snack/INITIALIZE_SNACK");

    // items del menu
    this.menuItems = [
      {
        title: "Cursos",
        icon: "mdi-calendar",
        path: "/cursos",
        roles: ["ROLE_SUPER_ADMIN"],
      },
      {
        title: "Personas",
        icon: "mdi-account-multiple",
        path: "/personas",
        roles: ["ROLE_SUPER_ADMIN"],
      },
      {
        title: "Prematrículas",
        icon: "mdi-pencil-box-multiple",
        path: "/prematriculas",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_SUPER_ADMIN_LLODIO"],
      },
      {
        title: "Notas",
        icon: "mdi-clipboard-account",
        path: "/notas",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_SUPER_ADMIN_LLODIO"],
      },
      {
        title: "Grupos",
        icon: "mdi-account-group",
        path: "/grupos",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_SUPER_ADMIN_LLODIO"],
      },
      {
        title: "Remesas",
        icon: "mdi-bank",
        path: "/remesas",
        roles: ["ROLE_SUPER_ADMIN"],
      },
      {
        title: "Listados",
        icon: "mdi-file-pdf-box",
        path: "/listados",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_SUPER_ADMIN_LLODIO"],
      },
    ];
  },
  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
      cursos: "GET_CURSOS",
    }),

    ...mapGetters("Snack", {
      snack: "GET_SNACK",
    }),

    ...mapGetters("Auth", {
      userRoles: "authRoles",
    }),
  },
  methods: {
    ...mapActions("Snack", {
      resetSnack: "RESET_SNACK",
    }),
    ...mapMutations("App", {
      setCursoActual: "SET_CURSO_ACTUAL",
    }),
    cursoChange(selected) {
      this.setCursoActual(selected);
    },
    async logout() {
      await this.$store.dispatch("Auth/LOGOUT").then(() =>
        this.$router.push("/login").catch((err) => {
          console.error(err);
        })
      );
    },
    isActive(listItemPath) {
      if (listItemPath === this.$route.path) {
        return "v-item--active v-list-item--active";
      }

      return "";
    },
  },
};
</script>
